// components/NetworkSpeedTest.tsx
import React from 'react';

interface NetworkSpeedTestProps {
  status: 'testing' | 'sufficient' | 'insufficient' | 'error';
  speedMbps: number | null;
}

export const NetworkSpeedTest: React.FC<NetworkSpeedTestProps> = ({ status, speedMbps }) => {
  const getStatusMessage = () => {
    switch (status) {
      case 'testing':
        return (
          <div className="flex items-center text-brand-text-secondary">
            <div className="w-4 h-4 border-2 border-brand-primary border-t-transparent rounded-full animate-spin mr-2"></div>
            <span>Testing network speed...</span>
          </div>
        );
      case 'sufficient':
        return (
          <div className="text-green-500">
            You have passed the speed test, you can start the exam.
          </div>
        );
      case 'insufficient':
        return (
          <div className="text-red-500">
            Your network speed is too low. A minimum of speed is required. Please connect to a better network to start the test.
          </div>
        );
      case 'error':
        return (
          <div className="text-red-500">
            Could not complete the network speed test. Please check your connection and try again.
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="p-4 my-4 border rounded-lg bg-brand-surface border-brand-border">
      <h3 className="font-bold mb-2 text-brand-text-primary">Network Check</h3>
      {getStatusMessage()}
    </div>
  );
};
